import {
  SET_IS_SIGN_IN,
  SET_USER_PROFILE
} from './mutation-types'

const mutations = {

  [SET_IS_SIGN_IN] (state, isSignIn) {
    state.isSignIn = isSignIn

    window.sessionStorage.setItem('isSignIn', JSON.stringify(isSignIn))
  },

  [SET_USER_PROFILE] (state, userProfile) {
    state.userProfile = userProfile

    window.sessionStorage.setItem('userProfile', JSON.stringify(userProfile))
  }
}

export default mutations
